import { render } from "./SettingPage.vue?vue&type=template&id=1e95f994&scoped=true"
import script from "./SettingPage.vue?vue&type=script&lang=js"
export * from "./SettingPage.vue?vue&type=script&lang=js"

import "./SettingPage.vue?vue&type=style&index=0&id=1e95f994&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e95f994"]])

export default __exports__